var _g, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamondTier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "avatars"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_36818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_107_36818",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_107_36818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#E9F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    d: "M12 21.333C15.6819 21.333 18.6667 20.4376 18.6667 19.333C18.6667 18.2284 15.6819 17.333 12 17.333C8.31814 17.333 5.33337 18.2284 5.33337 19.333C5.33337 20.4376 8.31814 21.333 12 21.333Z",
    fill: "#ACE8F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xEF\x8E\xA5",
    d: "M18.6025 11.1392L15.6855 6.85352C15.6074 6.74637 15.4772 6.66602 15.3469 6.66602H8.65339C8.52317 6.66602 8.39294 6.74637 8.31481 6.85352L5.39778 11.1392C5.2936 11.3267 5.31964 11.541 5.44987 11.6749L11.7006 18.5321C11.7788 18.6392 11.883 18.666 12.0132 18.666C12.1174 18.666 12.2215 18.6392 12.2997 18.5321L18.5505 11.6749C18.6807 11.541 18.7067 11.2999 18.6025 11.1392ZM15.3209 7.84459L17.4566 10.9517H13.0029L15.3209 7.84459ZM12.0132 10.8982L9.51287 7.52316H14.4875L12.0132 10.8982ZM8.67944 7.84459L10.9974 10.9517H6.54376L8.67944 7.84459ZM12.0132 17.6214L6.70002 11.8089H17.3003L12.0132 17.6214Z",
    fill: "#1FC0D7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xEF\x8E\xA5_2",
    d: "M15.4438 8.32143L17.5794 11.4286H13.1258L15.4438 8.32143ZM12.1361 11.375L9.63574 8H14.6103L12.1361 11.375ZM8.80231 8.32143L11.1203 11.4286H6.66663L8.80231 8.32143Z",
    fill: "url(#paint0_diamond_107_36818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xEF\x8E\xA5_3",
    d: "M12.4114 17.3333L7.73328 12H17.0666L12.4114 17.3333Z",
    fill: "url(#paint1_diamond_107_36818)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 11.3329,
    y: 1.33301,
    width: 1.33333,
    height: 4,
    rx: 0.666667,
    fill: "#1FC0D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16",
    x: 20.7104,
    y: 5.33301,
    width: 1.33333,
    height: 4,
    rx: 0.666667,
    transform: "rotate(57.6132 20.7104 5.33301)",
    fill: "#1FC0D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17",
    width: 1.33333,
    height: 4,
    rx: 0.666667,
    transform: "matrix(0.535633 -0.844451 -0.844451 -0.535633 6.04382 8.60156)",
    fill: "#1FC0D7"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_107_36818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8262 13.9026) rotate(90) scale(5.04911 5.45641)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FC0D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC0D7",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_diamond_107_36818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0013 12) rotate(90) scale(5.33333 3.16888)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FC0D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC0D7",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_36818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondTier);
export default __webpack_public_path__ + "static/media/diamond_tier.7a746ed5.svg";
export { ForwardRef as ReactComponent };